/**
 *
 * @param obj any object that is extends Record<string, any>
 * @returns an object where unwanted values are removed.
 * @description This function removes unwanted values from an object. It removes all values that are
 * undefined, null, or empty strings. It also removes any properties that are not of type boolean, number,
 * or string. \
 * example: \
 * const obj = { \
 *   a: 1, \
 *   b: null, \
 *   c: undefined, \
 *   d: '', \
 *   e: 0, \
 *   f: false, \
 *   g: true, \
 * }; \
 * const result = removeUnwantedValuesFromObject(obj); \
 * console.log(result); // { a: 1, e: 0, f: false, g: true }
 */
// biome-ignore lint/suspicious/noExplicitAny: Actual any is required here
export function removeUnwantedValuesFromObject<T extends Record<string, any>>(
  obj: T,
): Partial<T> {
  return Object.keys(obj).reduce(
    (acc, key) => {
      const value = obj[key];
      if (value || typeof value === 'boolean' || typeof value === 'number') {
        acc[key as keyof T] = value;
      }
      return acc;
    },
    {} as Partial<T>,
  );
}
